/**
 * Enum describing the if the uri location is handled by the application host
 */
export enum UriLocationType {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}
